import { useCallback, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import Autocomplete from '@gef-ui/form-material/Autocomplete';
import { validationDisplayTypes } from '@gef-ui/form-material/constants';
import Form from '@gef-ui/form-material/Form';
import SubmitButton from '@gef-ui/form-material/SubmitButton';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { urls } from 'features/common/fetch/constants';
import {
	fetchUsersSubordinates,
	handoverSelectedRAAnalysis,
} from 'features/views/roboAdvisory/roboAdvisoryHandover/actions';
import { dialogs } from 'features/views/roboAdvisory/roboAdvisoryHandover/constants';
import formDescriptorFn, {
	FIELDS,
	ROBO_ADVISORY_HANDOVER_FORM_NAME,
} from 'features/views/roboAdvisory/roboAdvisoryHandover/form';
import { getUserSubordinateUsers } from 'features/views/roboAdvisory/selectors';
import { userCodelistOptionsWithFullnamesAndLogins } from 'utils/user';

export const RAHandoverForm = () => {
	const dispatch = useDispatch();

	const userSubordinates = useSelector(getUserSubordinateUsers);
	const userSubordinatesOptions = userCodelistOptionsWithFullnamesAndLogins(userSubordinates);

	useEffect(() => {
		if (isNilOrEmpty(userSubordinates)) {
			dispatch(fetchUsersSubordinates());
		}
	}, [dispatch, userSubordinates]);

	const handleHandOver = useCallback(() => {
		dispatch(handoverSelectedRAAnalysis());
	}, [dispatch]);

	const handleOnClickError = useCallback(() => {
		dispatch(dialog.actions.open(dialogs.NO_SUBORDINATE_TO_HANDOVER, null, dialog.constants.WARNING));
	}, [dispatch]);

	return (
		<Form name={ROBO_ADVISORY_HANDOVER_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<Grid container>
				<Grid size={12}>
					<Grid container spacing={2} justifyContent="space-around">
						<Grid size={4}>
							<ComponentLoader fetchStorePath={fetch.constants.urls.userList}>
								<Autocomplete
									size="small"
									fieldName={FIELDS.handoverTo}
									label={getLabelMessage('roboAdvisory:handoverTo')}
									options={userSubordinatesOptions}
									labelPropName="name"
									valuePropName="code"
									validationDisplay={validationDisplayTypes.HIDDEN}
								/>
							</ComponentLoader>
						</Grid>
						<Grid size={12}>
							<Grid container justifyContent="flex-end">
								<Grid size={3}>
									<ComponentLoader fetchStorePath={urls.raHandover} ignoreErrors>
										<SubmitButton
											variant="contained"
											onClick={handleHandOver}
											onClickError={handleOnClickError}
											fullWidth
											text={getLabelMessage('roboAdvisory:handOverModalButton')}
										/>
									</ComponentLoader>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Form>
	);
};

export default RAHandoverForm;
